<template lang="pug">
  .additional-languages
    .languages-fields(v-for="index in items")
      .field.field-lang
        input.is-checkradio.custom-checkbox(
          type="checkbox"
          :id="'additional_language_' + index"
          v-if="additionalChosen[index - 1]"
          v-model="additionalChosen[index - 1]['active']"
          :disabled="disabled[index - 1]"
          )
        label.checkbox(:for="'additional_language_' + index")
        v-dropdown(
          v-if="languagesModify"
          :items="languagesModify"
          :all="languages"
          :option="gettext('Select language')"
          @default="$set(disabled, [index - 1], $event)"
          v-model="additionalChosen[index - 1]")
      .field.field-level
        v-dropdown(v-if="additionalChosen[index - 1]" :items="levels" :disabled="disabled[index - 1]" v-model="additionalChosen[index - 1]['level']")
    button.main-btn.language-btn(@click="addItem" :disabled="!languagesModify.length || disableButton") {{ gettext('Add language') }}

</template>
<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import VDropdown from './../dropdown'
const _ = require('lodash')
export default {
  name: 'AdditionalLanguages',
  data () {
    return {
      additionalChosen: [],
      items: 0,
      edit: false,
      disabled: []
    }
  },
  components: {
    VDropdown
  },
  props: {
    languages: {
      default: () => []
    },
    levels: {
      default: () => []
    },
    value: {
      default: () => []
    }
  },
  methods: {
    gettext: gettext,
    addItem () {
      this.edit = false
      this.items++
    },
    setChosen (data, edit = true) {
      this.edit = edit
      this.additionalChosen = _.filter(data)
      this.items = this.additionalChosen.length
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    languagesModify: function () {
      let result = _.differenceBy(this.languages, this.additionalChosen, 'iso_code')
      return _.each(result, (item, index) => {
        this.$set(result[index], 'active', true)
      })
    },
    disableButton: function () {
      return !!(this.disabled.filter(i => i)).length
    }
  },
  watch: {
    additionalChosen: {
      deep: true,
      handler: function (val) {
        if (!this.edit) {
          this.$emit('input', _.filter(val, item => {
            return item.active
          }))
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .language-btn {
    width: 100%;
    background-color: #b4b4b4;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    margin: 10px auto;
    height: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/language-filters/parts/additional-languages/index.vue